import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {ModelViewerService} from '@ispm-client/modules/segments/services/anatomy3dViewer.service';
import {IWidgetItem} from '@ispm/widgets/interfaces/widget-item.interface';
import {Widget} from '@ispm/widgets/decorator/widget.decorator';
import {ProstateMeshData} from '@ispm-client/modules/segments/interfaces/3dViewer';
import {Subject} from 'rxjs';
import {has, set} from 'lodash';
import {Store} from "@ngrx/store";
import {IPCOSummaryTableArray} from "@ispm/dynamic-form/interfaces/ISummaryTableInterface";
import {IgenomicsState} from "@ispm/core/interfaces/genomics-state.interface";
import {RouterManagerService} from "@ispm/core/services/router-manager.service";

@Component({
    selector: 'ispm-model-viewer',
    templateUrl: './model-viewer.component.html',
    styleUrls: ['./model-viewer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('ModelViewer')
export class ModelViewerComponent implements OnInit, IWidgetItem , OnDestroy {
    public meshData: ProstateMeshData;
    public summaryTableArry: IPCOSummaryTableArray;
    public modelViewerData: any;
    private width: number;
    private componentDestroyer$: Subject<any> = new Subject();
    private _originalReport: any=null;
    meshLoaded: boolean;
    public currentPatientId: any;
    public requestBody: any;
    public store$: Store<IPCOSummaryTableArray>;
    constructor(private modelViewerService: ModelViewerService,
                private _changeDetectionRef: ChangeDetectorRef,
                private store: Store<IgenomicsState>,
                private routerManagerService: RouterManagerService) {
        this.currentPatientId = this.routerManagerService.parameters.patientId;
        this.store$ = store.select('pcoSummaryTable') as any;
    }

    set widgetData(widgetData: any) {
        if (widgetData != undefined && widgetData.length > 0) {
            const widgetDataSorted = widgetData.sort((a, b) => (a.seriesTime > b.seriesTime ? -1 : 1));
            //this.modelViewerData = widgetDataSorted[0];
            if(widgetDataSorted[0] != undefined){
                this.modelViewerData = widgetDataSorted[0];
                this.getMeshData();
                this._changeDetectionRef.detectChanges();
                this._changeDetectionRef.markForCheck();
            }
        }
    }

    set widgetConfig(itemConfig: any) {
        const widgetPayload = itemConfig.widgetPayload;
        Object.assign(this, widgetPayload);
    }


    ngOnInit() { }

    private getMeshData(): void {
        if (this.modelViewerData) {
            this.modelViewerService.getDefaultMeshData(this.modelViewerData)
                .take(1)
                .subscribe((responseReturned) => {
                    this._originalReport = responseReturned[0] && responseReturned[0]['3dModelMeshData'];
                    let response = responseReturned[0] && responseReturned[0]['3dModelMeshData'];

                    if (has(response, 'prostateMeshUrl')) {
                        this.meshData = Object.assign({}, {
                            prostateMeshUrl: response.prostateMeshUrl,
                            biopsies: response.biopsies,
                            rois: response.rois,
                            reportData: response.reportData
                        });
                    } else {
                        this.meshData = null;
                    }
                    this.summaryTableArry = new class implements IPCOSummaryTableArray {
                        summary: Array<any>;
                        summaryTableModel: Array<any>;
                    }
                    this.store$.subscribe(summaryTableItem => {
                        if(summaryTableItem.summary != null){
                            this.summaryTableArry.summary = [...summaryTableItem.summary];
                        }
                        if(summaryTableItem.summaryTableModel !=null){
                            this.summaryTableArry.summaryTableModel = [...summaryTableItem.summaryTableModel];
                        }
                    });
                    this.meshLoaded = true;
                    this._changeDetectionRef.detectChanges();
                    this._changeDetectionRef.markForCheck();
                });
        } else {
            // Loads the default error message
            this.meshLoaded = true;
        }
    }

    updateReport(updateReport):void{
        set(this._originalReport,'reportData',updateReport);
        this.modelViewerService.updateReport(this._originalReport)
    }
    ngOnDestroy(): void {
        this.componentDestroyer$.next();
        this.componentDestroyer$.complete();
    }
}
